import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    name: 'Login'
  },
  {
    path: '/register',
    component: () => import('@/views/register/index'),
    name: 'Register'
  },
  {
    path: '/registerByIDCard',
    component: () => import('@/views/register/registerByIDCard/index'),
    name: 'RegisterByIDCard'
  },
  {
    path: '/registerByNumber',
      component: () => import('@/views/register/registerByNumber/index'),
    name: 'RegisterByNumber'
  },
  {
    path: '/registerFindPass',
      component: () => import('@/views/register/registerFindPass/index'),
    name: 'RegisterFindPass'
  }
]

export const dynamicRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        component: () => import('@/views/index'),
        name: 'Home',
        meta: { title: '首页', icon: '' }
      },
      {
        path: '/admin',
        component: () => import('@/views/admin_index'),
        name: 'aHome',
        meta: { title: '管理首页', icon: '' }
      },
      {
        path: '/order',
        component: () => import('@/views/product/order/index'),
        name: 'Order',
      },
      {
        path: '/orderSuccess',
        component: () => import('@/views/product/orderSuccess/index'),
        name: 'OrderSuccess',
      },
      {
        path: '/bannerAdd',
        component: () => import('@/views/settings/banner/add/index'),
        name: 'BannerAdd',
      },
      {
        path: '/navAdd',
        component: () => import('@/views/settings/nav/add/index'),
        name: 'NavAdd',
      },
      {
        path: '/teletextAdd',
        component: () => import('@/views/settings/teletext/add/index'),
        name: 'TeletextAdd',
      },
      {
        path: '/saleOrgConfigAdd',
        component: () => import('@/views/settings/saleOrgConfig/add/index'),
        name: 'SaleOrgConfigAdd',
      },
      {
        path: '/paySuccess',
        component: () => import('@/views/finance/paySuccess/index'),
        name: 'PaySuccess',
      },
      {
        path: '/signSuccess',
        component: () => import('@/views/finance/signSuccess/index'),
        name: 'signSuccess',
      },
      // {
      //   path: '/system/user/profile',
      //   component: () => import('@/views/system/user/profile/index'),
      //   name: 'Profile',
      //   meta: { title: '个人中心', icon: 'user' }
      // }
    ]
  }
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
